export default __webpack_public_path__ + "static/media/code-connect-challenge.2d3fe79b.png";